import React from "react"
import Image from "./Image"
import Gif from "./Gif"
import Mux from "./Mux"
import Video from "./Video"
import Wistia from "./Wistia"
import YouTube from "./YouTube"
import * as R from "ramda"

export enum MediaTypes {
  Image = "image",
  Gif = "gif",
  Mux = "mux",
  Video = "video",
  Wistia = "wistia",
  YouTube = "youtube",
}

const components = {
  [MediaTypes.Image]: Image,
  [MediaTypes.Gif]: Gif,
  [MediaTypes.Mux]: Mux,
  [MediaTypes.Video]: Video,
  [MediaTypes.Wistia]: Wistia,
  [MediaTypes.YouTube]: YouTube,
}

const propsList = {
  [MediaTypes.Image]: ["caption", "fullWidth", "mobileImage", "image"],
  [MediaTypes.Gif]: ["caption", "mobileGif", "gif"],
  [MediaTypes.Mux]: ["caption", "muxVideo", "muxMobileVideo", "autoplayVideo"],
  [MediaTypes.Video]: [
    "caption",
    "youtubeVideoId",
    "mobileVideoUrl",
    "videoUrl",
    "videoThumbnail",
    "customVideoThumbnail",
    "autoplayVideo",
  ],
  [MediaTypes.Wistia]: ["caption", "wistiaVideoId", "autoplayVideo"],
  [MediaTypes.YouTube]: ["caption", "youtubeVideoId"],
}

interface MediaProps {
  blockId?: string
  type: MediaTypes
  caption?: string
  mobileImage?: string
  image?: string
  fullWidth?: boolean
  mobileGif?: string
  gif?: string
  muxVideo?: {
    title: string
    video: {
      ratio: string
      ready: boolean
      assetId: string
      version: number
      duration: number
      audioOnly: boolean
      created_at: number
      playbackId: string
      max_stored_frame_rate: number
      max_stored_resolution: string
    }
  }
  muxMobileVideo?: {
    title: string
    video: {
      ratio: string
      ready: boolean
      assetId: string
      version: number
      duration: number
      audioOnly: boolean
      created_at: number
      playbackId: string
      max_stored_frame_rate: number
      max_stored_resolution: string
    }
  }
  wistiaVideoId?: string
  youtubeVideoId?: string
  mobileVideoUrl?: string
  videoUrl?: string
  videoThumbnail?: string
  customVideoThumbnail?: string
  autoplayVideo?: boolean
}

const Media: React.FC<MediaProps> = (props) => {
  const { type } = props
  const Component = components[type]
  const componentProps = R.pick(propsList[type], props) as any
  return <Component blockId={props.blockId} {...componentProps} />
}

export default Media
